/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineObject,
    InlineObjectFromJSON,
    InlineObjectToJSON,
    SignatureDTO,
    SignatureDTOFromJSON,
    SignatureDTOToJSON,
} from '../models';

export interface CreateOrUpdateSignatureRequest {
    managerId: number;
    text: string;
    inlineObject?: InlineObject;
}

export interface GetManagerSignatureRequest {
    managerId: number;
}

/**
 * 
 */
export class SignatureControllerApi extends runtime.BaseAPI {

    /**
     */
    async createOrUpdateSignatureRaw(requestParameters: CreateOrUpdateSignatureRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.managerId === null || requestParameters.managerId === undefined) {
            throw new runtime.RequiredError('managerId','Required parameter requestParameters.managerId was null or undefined when calling createOrUpdateSignature.');
        }

        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling createOrUpdateSignature.');
        }

        const queryParameters: any = {};

        if (requestParameters.managerId !== undefined) {
            queryParameters['managerId'] = requestParameters.managerId;
        }

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/signature`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObjectToJSON(requestParameters.inlineObject),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createOrUpdateSignature(requestParameters: CreateOrUpdateSignatureRequest, initOverrides?: RequestInit): Promise<void> {
        await this.createOrUpdateSignatureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getManagerSignatureRaw(requestParameters: GetManagerSignatureRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SignatureDTO>> {
        if (requestParameters.managerId === null || requestParameters.managerId === undefined) {
            throw new runtime.RequiredError('managerId','Required parameter requestParameters.managerId was null or undefined when calling getManagerSignature.');
        }

        const queryParameters: any = {};

        if (requestParameters.managerId !== undefined) {
            queryParameters['managerId'] = requestParameters.managerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/signature`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignatureDTOFromJSON(jsonValue));
    }

    /**
     */
    async getManagerSignature(requestParameters: GetManagerSignatureRequest, initOverrides?: RequestInit): Promise<SignatureDTO> {
        const response = await this.getManagerSignatureRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
